import React from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import { Grid, Form } from "@programari-limit/base-react";
import MuiGrid from "@mui/material/Grid";
import GridFormField from "components/GridFormField";

export const EmbarcacionsForm = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();

    return (
        <Form
            resourceName="embarcacio"
            id={id}
            titleCreate={t("embarcacions.create")}
            titleUpdate={t("embarcacions.update")}
            onGoBack={() => navigate(-1)}
        >
            <MuiGrid container spacing={2}>
                <GridFormField name="codi" lg={2} />
                <GridFormField name="compteCaixaEveret" lg={4} />
                <GridFormField name="codiClientEveret" lg={4} />
                <GridFormField name="nom" lg={6} />
                <GridFormField name="capacitat" lg={2} />
                <GridFormField name="observacions" lg={10} />
            </MuiGrid>
        </Form>
    );
};

const Embarcacions = () => {
    const { t } = useTranslation();

    const columns = [
        {
            name: "codi",
            flex: 0.75,
        },
        {
            name: "compteCaixaEveret",
            flex: 1,
        },
        {
            name: "codiClientEveret",
            flex: 1,
        },
        {
            name: "nom",
            flex: 2,
        },
        {
            name: "capacitat",
            flex: 1,
        },
    ];

    return (
        <Grid
            title={t("embarcacions.title")}
            resourceName="embarcacio"
            columns={columns}
            formRoutePath="form"
        />
    );
};

export default Embarcacions;
